import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Buffer } from 'buffer';
import process from 'process';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { icons } from './assets/icons';
import { Provider } from 'react-redux';
import store from './store';
import "./lang/i18nextInit";
// import axios from "src/actions/types";
import axios from 'axios';


window.Buffer = Buffer;
window.process = process;
React.icons = icons;



// =============== CHANGES BY MANSI ===============
// =============== CHANGES FOR DOCUMENT SANITIZATION (While uploading docs) ===============
const originalAppend = FormData.prototype.append;
FormData.prototype.append = function (name, value, filename) {
  if (value instanceof File) {
    const cleanName = value.name
      .trim()
      .replace(/\s+/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "");

    const sanitizedFile = new File([value], cleanName, { type: value.type });

    const finalFilename = filename
      ? filename.trim().replace(/\s+/g, "").replace(/[^a-zA-Z0-9._-]/g, "")
      : cleanName;

    return originalAppend.call(this, name, sanitizedFile, finalFilename);
  }
  return originalAppend.apply(this, arguments);
};

// ========= (Added a global API interceptor to automatically clear lists in the UI when the last item is deleted) =========
axios.interceptors.response.use(
  (response) => {
    // 1. To handle SUCCESS RESPONSES (Status 200) 
    if (response.status === 200) {
      const url = response.config.url ? response.config.url.toLowerCase() : "";

      // Feedback, Meetings 
      const isListRequest = url.includes("meeting") ||
        url.includes("feedback") ||
        url.includes("staff") ||
        url.includes("list") ||
        url.includes("get") ||
        url.includes("getall") ||
        url.includes("all");

      if (isListRequest) {
        // CASE A: response.data is empty (null/undefined/empty string)
        if (response.data === null || response.data === undefined || response.data === "") {
          response.data = [];
        }
        // CASE B: { success: false } or { status: false, data: null }
        else if (typeof response.data === 'object') {
          if (response.data.success === false || response.data.status === false) {
            response.data = [];
          } else if ('data' in response.data && (response.data.data === null || response.data.data === undefined)) {
            response.data.data = [];
          }
        }
      }
    }
    return response;
  },
  (error) => {
    // when only 404 error 
    if (error.response && error.response.status === 404) {
      const url = error.config.url ? error.config.url.toLowerCase() : "";
      const responseData = error.response.data || {};

      // 1. Strict URL Check
      const isListRequest = url.includes("meeting") ||
        url.includes("feedback") ||
        url.includes("staff") ||
        url.includes("list") ||
        url.includes("get") ||
        url.includes("all");

      // 2. Strict Message Check
      const hasNoDataMessage = responseData.success === 0 &&
        typeof responseData.message === 'string' &&
        responseData.message.toLowerCase().includes("no") &&
        responseData.message.toLowerCase().includes("found");

      // 3. AND (&&) Condition
      if (isListRequest && hasNoDataMessage) {
        return Promise.resolve({
          ...error.response,
          status: 200,
          data: []
        });
      }
    }
    return Promise.reject(error);
  }
);

// =============CHANGES END BY MANSI=========================



ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();